import { render, staticRenderFns } from "./ReviewMediaSection.vue?vue&type=template&id=f548594e&scoped=true"
import script from "./ReviewMediaSection.vue?vue&type=script&lang=js"
export * from "./ReviewMediaSection.vue?vue&type=script&lang=js"
import style0 from "./ReviewMediaSection.vue?vue&type=style&index=0&id=f548594e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f548594e",
  null
  
)

export default component.exports